(function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealObserver = null;
  var catalogRevealObserver = null;

  function elementsIn(root, selector) {
    if (!root) return [];
    var elements = [];
    if (root.nodeType === 1 && root.matches(selector)) elements.push(root);
    if (typeof root.querySelectorAll === 'function') {
      elements = elements.concat(Array.prototype.slice.call(root.querySelectorAll(selector)));
    }
    return elements;
  }

  function getRevealObserver() {
    if (revealObserver || !('IntersectionObserver' in window)) return revealObserver;
    revealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -6% 0px'
    });
    return revealObserver;
  }

  function initReveals(root, replay) {
    var elements = elementsIn(root || document, '[data-reveal]');
    if (!elements.length) return;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      elements.forEach(function (element) { element.classList.add('is-visible'); });
      return;
    }

    var observer = getRevealObserver();
    if (replay) {
      elements.forEach(function (element) {
        observer.unobserve(element);
        element.classList.remove('is-visible');
      });
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          elements.forEach(function (element) { observer.observe(element); });
        });
      });
      return;
    }

    elements.forEach(function (element) {
      if (!element.classList.contains('is-visible')) observer.observe(element);
    });
  }

  function initHero(root, replay) {
    var heroes = elementsIn(root || document, '.hero-content');
    heroes.forEach(function (hero) {
      if (reducedMotion) {
        hero.classList.add('is-ready');
        return;
      }
      if (!replay && hero.classList.contains('is-ready')) return;
      hero.classList.remove('is-ready');
      void hero.offsetWidth;
      requestAnimationFrame(function () { hero.classList.add('is-ready'); });
    });
  }

  function getCatalogRevealObserver() {
    if (catalogRevealObserver || !('IntersectionObserver' in window)) return catalogRevealObserver;
    catalogRevealObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.18,
      rootMargin: '0px 0px -8% 0px'
    });
    return catalogRevealObserver;
  }

  function bindCatalogArtMotion(card) {
    var art = card.querySelector('.product-art');
    if (!art || art.dataset.fastplusMotionBound === 'true' || reducedMotion) return;
    art.dataset.fastplusMotionBound = 'true';

    function resetMotion() {
      card.style.setProperty('--art-shift-x', '0px');
      card.style.setProperty('--art-shift-y', '0px');
      card.style.setProperty('--art-rotate', '0deg');
      card.style.setProperty('--art-scale', '1.02');
      card.style.setProperty('--art-glow-x', '50%');
      card.style.setProperty('--art-glow-y', '18%');
    }

    art.addEventListener('pointermove', function (event) {
      var rect = art.getBoundingClientRect();
      if (!rect.width || !rect.height) return;
      var x = ((event.clientX - rect.left) / rect.width) - 0.5;
      var y = ((event.clientY - rect.top) / rect.height) - 0.5;
      card.style.setProperty('--art-shift-x', (x * 14) + 'px');
      card.style.setProperty('--art-shift-y', (y * 10) + 'px');
      card.style.setProperty('--art-rotate', (x * 3.2) + 'deg');
      card.style.setProperty('--art-scale', '1.06');
      card.style.setProperty('--art-glow-x', (50 + x * 18) + '%');
      card.style.setProperty('--art-glow-y', (18 + y * 12) + '%');
    });
    art.addEventListener('pointerleave', resetMotion);
    art.addEventListener('pointercancel', resetMotion);
    resetMotion();
  }

  function initCatalogCards(root, options) {
    var replay = Boolean(options && options.replay);
    var visibleOnly = Boolean(options && options.visibleOnly);
    var cards = elementsIn(root || document, '.product-card').filter(function (card) {
      return Boolean(card.closest('.fastplus-all-products')) && (!visibleOnly || !card.hidden);
    });
    if (!cards.length) return;

    cards.forEach(bindCatalogArtMotion);
    if (reducedMotion || !('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.remove('motion-ready');
        card.classList.add('is-visible');
      });
      return;
    }

    var observer = getCatalogRevealObserver();
    cards.forEach(function (card, index) {
      observer.unobserve(card);
      card.style.setProperty('--card-reveal-delay', ((index % 4) * 60) + 'ms');
      card.classList.add('motion-ready');
      if (replay || !card.classList.contains('is-visible')) card.classList.remove('is-visible');
    });

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        cards.forEach(function (card) { observer.observe(card); });
      });
    });
  }

  function init(root, options) {
    var replay = Boolean(options && options.replay);
    initReveals(root || document, replay);
    initHero(root || document, replay);
    initCatalogCards(root || document, { replay: replay });
  }

  function onSectionLoad(event) {
    init(event.target || document);
  }

  function onSectionReorder() {
    init(document);
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:reorder', onSectionReorder);

  var mutationObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes, function (node) {
        if (node.nodeType === 1) init(node);
      });
    });
  });

  function start() {
    init(document);
    if (document.body) mutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.fastplus-all-products [data-category]');
    if (!button) return;
    window.setTimeout(function () {
      initCatalogCards(document, { replay: true, visibleOnly: true });
    }, 0);
  });

  document.addEventListener('input', function (event) {
    if (!event.target.matches('.fastplus-all-products [data-catalog-search]')) return;
    window.setTimeout(function () {
      initCatalogCards(document, { replay: true, visibleOnly: true });
    }, 0);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  window.FastplusSectionMotion = {
    init: init,
    initCatalogCards: initCatalogCards,
    initHero: initHero,
    initReveals: initReveals
  };
})();
